import { httpServiceClient } from '@/infra/http'
import { makeApiUrl } from '@/main/factories/http/api-url-factory'
import { ProductFitScoreResponse } from './product-fit-score-service-types'
import { formatProductFitScore } from './product-fit-score-service-utils'

const getProductFitScoreUrl = (productId: number) =>
  makeApiUrl(`/catalog/v2/products/${productId}/fit-score`)

export const createProductFitScoreService = (client = httpServiceClient) => ({
  async fetchProductFitScore(productId: number) {
    const response = await client<ProductFitScoreResponse>({
      method: 'get',
      url: getProductFitScoreUrl(productId)
    })

    return formatProductFitScore(response.body.data as ProductFitScoreResponse)
  }
})

export const productFitScoreService = createProductFitScoreService()
